import styled from "styled-components";

export const ButtonContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: left;
  margin-top: 16px;
`;
